import { autoinject, bindable } from 'aurelia-framework';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { camelCase } from 'lodash';
import { ResourceService } from '../../../../utils/resourceService';
import { IValidationErrorsAM } from '../../../../utils/validation';
import { ICostCenterAM } from '../../cost-centers/cost-center-api';
import * as moment from 'moment';
import { CostCenterDateEdit } from './cost-center-date-edit';

@autoinject
export class AddCostCenter {
	@bindable addingCostCenter: (params: any) => Promise<Response>;

	newCostCenter: ICostCenterAM = { identifier: null, name: null, activeFrom: null, activeUntil: null };
	validationController: ValidationController;
	costCenterDateEdit: CostCenterDateEdit;

	constructor(validationControllerFactory: ValidationControllerFactory, private resourceService: ResourceService) {
		this.validationController = validationControllerFactory.createForCurrentScope();
		this.attachValidationRules(this.newCostCenter);
		this.costCenterDateEdit = new CostCenterDateEdit(this.newCostCenter);
	}

	async submit() {
		const result = await this.validationController.validate({ object: this.newCostCenter });
		if (!result.valid) {
			return;
		}

		const response = await this.addingCostCenter({ costCenter: this.newCostCenter });

		if (response.status === 200) {
			this.handleSubmitSuccess();
		} else {
			await this.handleSubmitError(response);
		}
	}

	private handleSubmitSuccess() {
		this.newCostCenter = { identifier: null, name: null, activeFrom: null, activeUntil: null };
		this.attachValidationRules(this.newCostCenter);
	}

	private async handleSubmitError(response: Response) {
		const errors = await response.json() as IValidationErrorsAM;
		for (const key in errors) {
			if (!errors.hasOwnProperty(key)) { continue; }
			errors[key].forEach(message => {
				this.validationController.addError(
					this.resourceService.getResource(message),
					this.newCostCenter,
					camelCase(key)
				);
			});
		}
	}

	private attachValidationRules(costCenter: ICostCenterAM) {
		ValidationRules
			.ensure((c: ICostCenterAM) => c.identifier)
				.required()
				.withMessageKey('CostCenter_ValidationError_IdentifierIsRequired')
			.ensure((c: ICostCenterAM) => c.name)
				.required()
				.withMessageKey('CostCenter_ValidationError_NameIsRequired')
			.on(this.newCostCenter);
	}
}
